"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Blur_native_exports = {};
__export(Blur_native_exports, {
  Blur: () => Blur
});
module.exports = __toCommonJS(Blur_native_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react_native = require("react-native");
var import_OneNativeBlurNativeComponent = __toESM(require("../specs/OneNativeBlurNativeComponent"), 1);
function Blur(props) {
  var { intensity = 50, tint = "default", style, children, ...viewProps } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react_native.View, {
    style: [
      {
        backgroundColor: "transparent"
      },
      style
    ],
    ...viewProps,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_OneNativeBlurNativeComponent.default, {
        tint,
        intensity: Math.max(0, Math.min(1, intensity / 100)),
        style: {
          position: "absolute",
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        }
      }),
      children
    ]
  });
}
//# sourceMappingURL=Blur.native.js.map
